// Canonical mapping for category keys -> public categoryLevel1 values
// Use this whenever building search URLs or comparing category values
// to avoid camelCase/snake_case drift between components.
export const CATEGORY_VALUE_MAP = Object.freeze({
  technicalSuits: 'technical_suits',
  trainingSuits: 'training_suits',
  swimCaps: 'swim_caps',
  goggles: 'goggles',
  trainingGear: 'training_gear',
  techAndWearables: 'tech_wearables',
  bagsAndBackpacks: 'bags_backpacks',
  clothing: 'clothing',
  accessories: 'accessories',
  other: 'other',
  swimFins: 'swim_fins',
  snorkels: 'snorkels',
  paddles: 'paddles',
  kickboards: 'kickboards',
});

export const categoryValue = key => CATEGORY_VALUE_MAP[key] || key;

export const categoryQueryParam = key => ({
  pub_categoryLevel1: categoryValue(key),
});
